/** Digits only with country code, no + (for wa.me URLs). */
export function cleanPhoneForWhatsApp(phone: string): string {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits;
}

export function openWhatsApp(phone: string, prefilledText?: string): void {
  const cleaned = cleanPhoneForWhatsApp(phone);
  if (!cleaned) return;
  const url = `https://wa.me/${cleaned}${
    prefilledText ? `?text=${encodeURIComponent(prefilledText)}` : ""
  }`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function openSms(phone: string, body?: string): void {
  const cleaned = cleanPhoneForWhatsApp(phone);
  if (!cleaned) return;
  const url = body
    ? `sms:${cleaned}?body=${encodeURIComponent(body)}`
    : `sms:${cleaned}`;
  window.open(url, "_self");
}

export const WHATSAPP_TEMPLATES = [
  {
    id: "intro",
    label: "Introduction",
    build: (leadName: string) =>
      `Hi ${leadName || "there"}, this is regarding your enquiry. I'd love to help you with the details. When would be a good time to connect?`,
  },
  {
    id: "followup",
    label: "Follow-up",
    build: (leadName: string) =>
      `Hi ${leadName || "there"}, just following up on our conversation. Please let me know if you have any questions or would like to schedule a visit.`,
  },
  {
    id: "brochure",
    label: "Brochure",
    build: (leadName: string) =>
      `Hi ${leadName || "there"}, sharing the project brochure as discussed. Happy to walk you through the options whenever you're free.`,
  },
] as const;
